import type { ChipContent, ScriptElement } from '@/lib/schema.types';

export function ChipElement({ element }: { element: ScriptElement }) {
  const c = element.content as ChipContent | undefined;
  return (
    <span
      className="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
      style={{
        background: (element.style?.backgroundColor as string | undefined) ?? '#e0e7ff',
        color: (element.style?.color as string | undefined) ?? '#1f2937',
      }}
    >
      {c?.label ?? 'Chip'}
    </span>
  );
}
